<template>
  <div>
    <el-form
      :inline="true"
      :model="searchData"
      class="demo-form-inline"
      @keydown.enter.native="
        inSearch = true;
        saveData = false;
        page = 1;
        getData('enter');
      "
    >
      <el-form-item label="預計撥款日">
        <el-date-picker
          v-model="currentDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="高代號" v-if="$permission('admin')">
        <el-input v-model="searchData.agent_id" placeholder="高代號"></el-input>
      </el-form-item>
      <el-form-item
        label="商戶號"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
      >
        <el-input v-model="searchData.customer_id" placeholder="商戶號">
        </el-input>
      </el-form-item>
      <el-form-item label="撥款模式">
        <el-select
          filterable
          v-model="searchData.grant_type"
          :placeholder="searchData.grant_type == 2 ? 'T+11' : '撥款模式'"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="T+3" value="0"></el-option>
          <el-option label="T+11" value="1"></el-option>
          <!-- <el-option label="T+11" value="2"></el-option> -->
          <el-option label="T+0" :value="3"></el-option>
          <el-option label="T+1" :value="4"></el-option>
          <el-option label="T+2" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="類型">
        <el-select filterable v-model="searchData.groupBy" placeholder="類型">
          <el-option label="訂單" value=""></el-option>
          <el-option label="撥款日" value="grant_at"></el-option>
          <el-option label="商戶" value="customer_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋
        </el-button>
      </el-form-item>
    </el-form>
    <p style="margin-top:18px;font-size:18px">
      <span>
        共{{ dataList.total || 0 }}筆
        <span v-if="date.start">
          ，訂單區間：{{ date.start }}～{{ date.end }}
        </span>
      </span>
    </p>
    <p style="margin-top:5px;font-size:18px" v-if="sum">
      實收金額總計：{{ sum.amount_customer || 0 | decimalPoint | thousands }}
    </p>
    <div class="export">
      <el-button size="mini" @click="exportData">導出數據</el-button>
    </div>
    <el-table
      v-if="currentType"
      stripe
      :data="dataList.data"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        v-if="currentType == 'customer_id'"
        header-align="center"
        align="center"
        prop="customer_id"
        label="商戶號"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.customer_id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        header-align="center"
        align="center"
        prop="grant_at"
        label="撥款日"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.grant_at ? $returnTime(scope.row.grant_at) : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="amount_customer"
        label="實收金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.amount_customer | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="!currentType"
      stripe
      :data="dataList.data"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        width="400"
        header-align="center"
        align="left"
        prop="ct_id"
        label="商戶訂單號"
        key="1"
      >
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.ct_id">商戶訂單號 {{ scope.row.ct_id }}</p>
            <p
              v-if="
                scope.row.rc_feedback &&
                  JSON.parse(scope.row.rc_feedback).payer_info
              "
            >
              付款人帳號/店號
              {{ JSON.parse(scope.row.rc_feedback).payer_info }}
            </p>
            <p v-if="scope.row.tripartite_id">
              繳款帳號/代碼 {{ JSON.parse(scope.row.rc_feedback).bank_no }}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="transaction_id"
        label="訂單號"
        width="200px"
        key="2"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="customer_id"
        key="3"
        label="商戶號"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="amount_customer"
        label="實收金額"
        key="4"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.amount_customer | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="撥款模式">
        <template slot-scope="scope">
          <div>
            {{ grantType[scope.row.grant_type] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="created_at"
        label="創建時間"
        key="5"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="completed_at"
        label="完成時間"
        key="6"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="grant_at"
        label="撥款日"
        key="7"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.grant_at ? $returnTime(scope.row.grant_at) : "" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="dataList.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      grantType: ["T+3", "T+11", "T+11", "T+0", "T+1", "T+2"],
      searchData: {},
      currentDate: "",
      sum: [],
      dataList: [],
      pagination: {},
      page: 1,
      saveData: false,
      inSearch: false,
      date: {},
      currentType: ""
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    exportData() {
      let saveData = JSON.parse(JSON.stringify(this.saveData));
      this.$confirm("導出數據").then(e => {
        if (e == "confirm") {
          let params = saveData || {};
          params.export = 1;
          this.$http.get(`/back/stats/grant?export=1`, { params }).then(res => {
            if (res.data.code == 0) {
              window.open(`/back/export/${res.data.data}`);
            }
          });
        }
      });
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http.get(`/back/stats/grant`, { params: searchData }).then(res => {
        if (res.data.code == 0) {
          this.saveData = JSON.parse(JSON.stringify(searchData));
          this.inSearch = false;
          if (searchData.groupBy) {
            this.dataList = false;
          }

          if (searchData.groupBy == "grant_at") {
            this.currentType = "grant_at";
            if (Array.isArray(res.data.data.record.data)) {
              this.dataList = res.data.data.record;
            } else {
              try {
                let record = res.data.data.record;
                record.data = Object.values(res.data.data.record.data);
                this.dataList = record;
              } catch {
                console.error("123");
              }
            }
            this.date = res.data.data.date;
            this.sum = res.data.data.sum[0];
            return;
          }

          if (searchData.groupBy == "customer_id") {
            this.currentType = "customer_id";
            if (Array.isArray(res.data.data.record.data)) {
              this.dataList = res.data.data.record;
            } else {
              try {
                let record = res.data.data.record;
                record.data = Object.values(res.data.data.record.data);
                this.dataList = record;
              } catch {
                console.error("123");
              }
            }
            this.date = res.data.data.date;
            this.sum = res.data.data.sum[0];
            return;
          }
          this.currentType = "";
          if (Array.isArray(res.data.data.transactions.data)) {
            this.dataList = res.data.data.transactions;
          } else {
            try {
              let transactions = res.data.data.transactions;
              transactions.data = Object.values(
                res.data.data.transactions.data
              );
              this.dataList = transactions;
            } catch {
              console.error("123");
            }
          }
          this.date = res.data.data.date;
          this.sum = res.data.data.sum[0];
        }
      });
    },
    showDetails() {}
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: flex;
  justify-content: flex-end;
}
</style>
